var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.actualComponent,_vm._b({tag:"component",staticClass:"relative flex items-center justify-center gap-2 cursor-pointer rounded-[4px] font-[Nunito] transition-colors",class:[
    _vm.bgColor,
    _vm.textColor,
    _vm.borderColor,
    {
      'w-full': _vm.expanded,
      '!cursor-not-allowed': _vm.disabled,
      'border-solid border-2': _vm.outline,
      'p-[0.25rem] !text-xs': _vm.size === 'sm',
      'py-[0.5rem] px-[0.75rem]': _vm.size === 'md',
      'px-[0.625rem] py-[0.625rem] !text-xl font-bold': _vm.size === 'lg',
      'px-[1.5rem] py-[1.5rem] !text-2xl font-bold': _vm.size === 'xl',
      'inline-flex': _vm.inline,
      '!p-0.5': _vm.outline && _vm.size === 'sm',
      '!py-1.5 !px-2.5': _vm.outline && _vm.size === 'md',
      '!p-3': _vm.outline && _vm.size === 'lg',
      '!p-6': _vm.outline && _vm.size === 'xl',
    },
  ],attrs:{"title":_vm.title,"type":_vm.isSubmit ? 'submit' : 'button',"href":_vm.href ?? _vm.to,"to":_vm.to},on:{"click":_vm.onClick}},'component',_vm.$attrs,false),[(_vm.iconLeft && !_vm.loading && !_vm.disabled)?_c('IconComponent',{class:_vm.iconLeftClass,attrs:{"icon":_vm.iconLeft,"pack":_vm.iconLeftPack}}):_vm._e(),(_vm.loading)?_c('IconComponent',{staticClass:"animate-spin",attrs:{"icon":"spinner","pack":"fas"}}):_vm._e(),(_vm.disabled)?_c('IconComponent',{attrs:{"icon":"ban","pack":"fas"}}):_vm._e(),_vm._t("default"),(_vm.iconRight)?_c('IconComponent',{attrs:{"icon":_vm.iconRight,"pack":_vm.iconRightPack}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }